import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import withStyles, { ThemeProvider } from 'react-jss'
import classNames from 'classnames'

import { getBackgroundImageCss } from '@elo-kit/utils/themes.utils'

import { getFirstCoverUrl, getProductPrice, getCurrencyIdFromProduct } from 'utils/product.utils'
import { getLinkByParams } from 'utils/embeddableItems.utils'

import embeddableItemStyles from '../embeddableItemStyles'

const ProductPrice = ({ classes, convertToPrice, product }) => (
  <div className={classes.priceContainer} translate='no'>
    <span className={classes.price}>{convertToPrice(product.displayPrice, product.displayCurrencyId)}</span>
  </div>
)

@inject('currenciesStore', 'productsStore')
@observer
class Badge extends Component {
  render() {
    const {
      currenciesStore: { convertToPrice, getId },
      forSlider,
      productLink,
      productLink: { embedPrefs },
      classes,
      productsStore,
    } = this.props

    const product = forSlider ? this.props.product : productsStore.item
    const url = getLinkByParams(productLink, product)

    const currencyId = getId(getCurrencyIdFromProduct(product))
    const productPrice = convertToPrice(getProductPrice(product), currencyId)

    return (
      <div className={classes.boxShadowFix}>
        <div className={classes.badgeContainer}>
          {embedPrefs.priceTagEnabled && (
            <ProductPrice
              {...{
                classes,
                productPrice,
                product,
                convertToPrice,
              }}
            />
          )}
          <div className={classes.backgroundImageContainer}>
            {getFirstCoverUrl(product, 's640') ? (
              <div
                style={{ backgroundImage: getBackgroundImageCss(getFirstCoverUrl(product, 's640')) }}
                className={classes.productCover}
              />
            ) : (
              <i className='far fa-image m-auto' />
            )}
          </div>
          <div className={classes.productBackground}>
            <div className={classes.productName}>{product.name}</div>
            <div className={classes.buttonContainer}>
              <button
                type='button'
                onClick={() => window.open(url)}
                className={classNames(classes.button, classes[embedPrefs.buttonAnimation])}
              >
                {embedPrefs.buttonText}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const StyledBadge = withStyles(embeddableItemStyles)(Badge)

const BadgeContainer = (props) => (
  <ThemeProvider theme={props.productLink.embedPrefs}>
    <StyledBadge {...props} />
  </ThemeProvider>
)

export default BadgeContainer
